import { msg } from "@lingui/core/macro";

/**
 * User notices for the outcome of "revoke session" from Settings (CC-60).
 *
 * The user must hear the TRUTH: a rejected revocation (500) says the device is still
 * signed in, never that it was signed out. Extracted from BootManager so the wording and
 * the refresh are testable without mounting the provider.
 */

export interface RevokeNoticeDeps {
  showToast: (message: string, tone: "success" | "error") => void;
  t: (message: ReturnType<typeof msg>) => string;
  /** Refreshes the active sessions list, so it shows the REAL state after either outcome. */
  refreshSessions: () => void;
}

export function revokeNotices(deps: RevokeNoticeDeps) {
  return {
    onRevokeSuccess: () => {
      deps.showToast(deps.t(msg`Session revoked. That device has been signed out.`), "success");
      deps.refreshSessions();
    },
    onRevokeError: () => {
      deps.showToast(
        deps.t(msg`Could not revoke the session. That device is still signed in.`),
        "error",
      );
      deps.refreshSessions();
    },
  };
}
